import React from "react";

const height = (s, m, l, v) => {
  if (v) return v;
  if (l) return 24;
  if (m) return 16;
  if (s) return 8;
  return 5;
};

export const VerticalSpace = ({ s, m, l, v }) => (
  <div style={{ height: height(s, m, l, v) }} />
);
